import './App.css';
import GithubUserSearch from './GithubUserSearch';

function App() {
  return (
    <div className="App">
      <GithubUserSearch/>
    </div>
  );
}

export default App;
